import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const UkraineMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Ukraine</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              6 years (5 years academic + 1 year clinical internship)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB</li>
              <li>NEET qualification is mandatory (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, WFME, ECFMG</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <p className="detail-text">
              Affordable tuition, strong European curriculum, wide Indian
              student community.
            </p>
          </div>
          <div className="special-note">
            <p>
              ⚠️ **Note:** Due to the ongoing geopolitical situation,
              admissions, safety, and academic continuity must be carefully
              evaluated.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in Ukraine (based on historical
            rankings)
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Bogomolets National Medical University, Kyiv
              </h3>
              <p className="university-description">
                One of the oldest and most prestigious medical universities in
                Ukraine. NMC, WHO, and ECFMG recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Kharkiv National Medical University, Kharkiv
              </h3>
              <p className="university-description">
                Popular among Indian students. English-medium MD program.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Lviv National Medical University, Lviv
              </h3>
              <p className="university-description">
                Established in 1784. Known for academic excellence and historic
                campus.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Vinnitsa National Medical University, Vinnytsia
              </h3>
              <p className="university-description">
                Government-run and WHO/NMC approved. Strong Indian student base.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Ternopil National Medical University, Ternopil
              </h3>
              <p className="university-description">
                Offers affordable MBBS in English. WHO and NMC recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Danylo Halytsky Lviv National Medical University, Lviv
              </h3>
              <p className="university-description">
                Well-equipped labs and clinical exposure. Popular for dental and
                medical programs.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Ivano-Frankivsk National Medical University, Ivano-Frankivsk
              </h3>
              <p className="university-description">
                NMC-approved and English-medium instruction. One of the top
                choices pre-2022.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Zaporizhzhia State Medical University, Zaporizhzhia
              </h3>
              <p className="university-description">
                Offers low-cost MBBS. WHO and NMC recognized.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default UkraineMbbs;
